export function axIsInstanceOfObject(x) {
    return this.dPrototype.isPrototypeOf(this.sec.box(x));
}
